import { createGlobalStyle } from 'styled-components'
import theme from '../styles/theme'

const GlobalStyle = createGlobalStyle`
  *,
  *::after,
  *::before {
    font-family: "Open sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
    box-sizing: border-box;
  }

  html {
    background: ${theme.color.ui1};
    color: ${theme.color.text1};
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  p {
    font-family: 'Open Sans', sans-serif;
    margin: 0;
  }
  
  a {
    text-decoration: none;
  }

  ul {
    margin: 0;
    padding: 0;
  }
`

export default GlobalStyle
